import(/* webpackMode: "eager" */ "/codebuild/output/src1517586881/src/app/global-error.prod.tsx");
